import React, { useState, useCallback } from 'react';
import CodeEditor from './components/CodeEditor';
import AIAssistant from './components/AIAssistant';
import { detectError, analyzeError } from './utils/errorDetection';
import { getAIAssistance } from './services/ai-service';
import './App.css';

function App() {
  const [code, setCode] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCodeChange = useCallback(async (newCode) => {
    setCode(newCode);
    
    const error = detectError(newCode);
    if (error) {
      setHasError(true);
      setIsLoading(true);
      
      // ローカル分析
      const analysis = analyzeError(error);
      
      // AI分析を実行
      const aiResponse = await getAIAssistance(newCode, error);
      
      setSuggestion(`
## エラーが検出されました ❌

**${error.message}**

### AIアシスタントの分析
${aiResponse}

### クイックガイダンス
${analysis.guidance}

### ヒント
${analysis.tips.map(tip => `- ${tip}`).join('\n')}
      `);
      
      setIsLoading(false);
    } else {
      setHasError(false);
      setSuggestion(`
## コードは正常です ✅

エラーは検出されませんでした。コードは正常に動作する可能性があります。

### ヒント
- コードの実行結果を確認してみましょう
- 変数名や関数名をわかりやすくすると良いでしょう
- コメントを追加すると、後で見返しやすくなります
      `);
    }
  }, []);

  return (
    <div className="App">
      <header className="header">
        <div className="header-content">
          <h1>AI ペアプログラミングアシスタント</h1>
          <p>JavaScriptのコードを書いてみましょう。エラーが出たら、AIがフレンドリーにサポートします。</p>
        </div>
      </header>
      
      <main className="main-content">
        <div className="editor-container">
          <div className="editor-wrapper">
            <CodeEditor code={code} onChange={handleCodeChange} />
          </div>
          <div className="assistant-wrapper">
            <AIAssistant 
              suggestion={suggestion} 
              hasError={hasError}
              isLoading={isLoading}
            />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;